import { Component, HostListener, OnDestroy, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { AuthenticationServices } from "../../services/authentication.services";


@Component({
  selector: 'app-tab-selector',
  template: '<a>{{ year ? year : { name: month, language: this.activeUser.language } | monthTransform }}</a>',
  encapsulation: ViewEncapsulation.None
})

export class AppTabSelector implements OnInit, OnDestroy {
  constructor(
    private activeUser: AuthenticationServices
  ) {}

  @Input() year: number;
  @Input() month: number;
  @Input() cursor: any;
  @Output() setTab: any = new EventEmitter();

  @HostListener('click', ['$event']) onClick( event: any ) {
    this.year ? this.setTab.emit({ year: this.year }) : this.setTab.emit({ month: Number(this.month) });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/components/app-tab-selector/app-tab-selector.component.ts